import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="tranxaction-form"
export default class extends Controller {
	connect() {
		this.element.addEventListener("turbo:submit-start", this.onSubmitStart)
	}

	disconnect() {
		this.element.removeEventListener("turbo:submit-start", this.onSubmitStart)
	}

	updateDebit(event) {
		const { fieldId } = event.params

		const debitField = document.getElementById(fieldId)

		debitField && (debitField.value = null)
	}

	updateCredit(event) {
		const { fieldId } = event.params

		const creditField = document.getElementById(fieldId)

		creditField && (creditField.value = null)
	}

	/** @param {Turbo.TurboSubmitStartEvent} event */
	onSubmitStart = (event) => {
		const { formSubmission } = event.detail
		const { body: formData } = formSubmission

		const keys = []
		formData.forEach((value, key) => {
			if (/debit|credit/.test(key)) {
				if (!value || Number(value) <= 0) keys.push(key)
			}
		})
		keys.forEach(key => formData.delete(key))
	}
}
